import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { CSSProperties } from 'react';
import CubeMark from './CubeMark';

type SimpleLogoProps = {
    className?: string;
    style?: CSSProperties
}

const LogoLink = styled(Link)`
    position: relative;
    display: inline-flex;
    align-items: center;
    column-gap: 0.2em;
    color: ${({ theme }) => theme.colour.OFF_WHITE};
    font-size: 26px;
    font-family: ${({ theme }) => theme.font.FONT_SANS_RED_HAT_DISPLAY};
    font-weight: 900;
    text-transform: uppercase;
    line-height: 1;
    z-index: 2;
`

const LogoMark = styled(CubeMark)`
    width: 0.88em;
    height: 0.86em;
    flex-shrink: 0;
    overflow: visible;
    /* centres the cube on the cap height rather than the line box */
    transform: translateY(-0.02em);
`

export default function TextLogo({className, style}: SimpleLogoProps){
    return (
        <LogoLink to={'home'} className={className} style={style}>
            O'Neill
            <LogoMark />
        </LogoLink>
    )
}
